import { render } from "./QuotationStep2Priority.vue?vue&type=template&id=77843060&scoped=true"
import script from "./QuotationStep2Priority.vue?vue&type=script&lang=js"
export * from "./QuotationStep2Priority.vue?vue&type=script&lang=js"

import "./QuotationStep2Priority.vue?vue&type=style&index=0&id=77843060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77843060"]])

export default __exports__